import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';

const FirstLevelNavList = (props) => {
  const { tag, items, itemTag, activeParentId, onItemClick } = props;
  const NavTag = tag;
  const ItemTag = itemTag;

  const onClick = (event, id) => {
    onItemClick(id, items);
  };

  return (
    <nav
      className="overflow-hidden w-auto whitespace-normal"
      aria-label="First level"
    >
      <a
        className="text-base text-black absolute w-px h-px -left-96 top-auto
        focus:h-auto focus:w-auto focus:m-auto focus:left-0 focus:top-0 bg-white focus:inline-block"
        href="#main-content"
      >
        Skip Navigation
      </a>
      <NavTag className="w-32.4 bg-blue-600 h-siderbar list-none p-0 m-0 overflow-y-auto">
        {items.map((item) => {
          const { id } = item;
          if (
            typeof item.isVisible === 'function' &&
            item.isVisible() === false
          ) {
            return null;
          }
          return (
            <ItemTag
              key={id}
              isActive={id === activeParentId}
              containerTag={tag}
              item={item}
              onClick={onClick}
            />
          );
        })}
      </NavTag>
    </nav>
  );
};

FirstLevelNavList.propTypes = {
  items: PropTypes.array.isRequired,
  tag: PropTypes.string,
  itemTag: PropTypes.func.isRequired,
  activeParentId: PropTypes.string.isRequired,
};

FirstLevelNavList.defaultProps = {
  className: null,
  tag: 'ul',
};

export default withRouter(FirstLevelNavList);
